import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import tableBaseMixin from './tableBaseMixin';
const RENDER_TYLES = ['text', 'image', 'tag', 'state', 'link', 'complex', 'actions', 'template', 'custom', 'function'];
let AmTableColumnMixin = class AmTableColumnMixin extends Mixins(tableBaseMixin) {
  get columnLabel() {
    var _this$label, _this$label2;
    if (typeof this.label === 'string') return this.label;
    if ((_this$label = this.label) !== null && _this$label !== void 0 && _this$label.i18nKey) return this.lowcode.i18n.get(this.label.i18nKey, this.label.value);
    return ((_this$label2 = this.label) === null || _this$label2 === void 0 ? void 0 : _this$label2.value) || '';
  }
  get isTypedRenderType() {
    return !!this.type;
  }
  get isTextRenderType() {
    return this.renderType === 'text' || !this.renderType || !RENDER_TYLES.includes(this.renderType);
  }
  get isImageRenderType() {
    return this.renderType === 'image';
  }
  get isTagRenderType() {
    return this.renderType === 'tag';
  }
  get isStateRenderType() {
    return this.renderType === 'state';
  }
  get isLinkRenderType() {
    return this.renderType === 'link';
  }
  get isComplexRenderType() {
    return this.renderType === 'complex';
  }
  get isActionsRenderType() {
    return this.renderType === 'actions';
  }
  get isTemplateRenderType() {
    return this.renderType === 'template';
  }
  get isCustomRenderType() {
    return this.renderType === 'custom';
  }
  get isFunctionRenderType() {
    return this.renderType === 'function';
  }
  get formattedActions() {
    var _this$actions;
    if (!this.isActionsRenderType) return [];
    let formattedActions = [];
    let groupedActions = {};
    (_this$actions = this.actions) === null || _this$actions === void 0 || _this$actions.forEach(action => {
      const {
        group
      } = action;
      if (!group) formattedActions.push(action);else {
        if (!groupedActions[group]) groupedActions[group] = {
          title: group,
          type: 'group',
          // 分组按钮下的子按钮
          subActions: []
        };
        let {
          subActions
        } = groupedActions[group];
        subActions.push({
          title: action.title,
          action: action.action
        });
      }
    });
    return formattedActions.concat(Object.values(groupedActions));
  }
  get config() {
    return this.builtInTemplateConfig || {};
  }
  getContent(row) {
    return this.prop ? row[this.prop] : void 0;
  }
  getImageSrc(row) {
    var _this$lowcode;
    const src = this.prop ? row[this.prop] : '';
    return src ? ((_this$lowcode = this['lowcode']) === null || _this$lowcode === void 0 || (_this$lowcode = _this$lowcode.utils) === null || _this$lowcode === void 0 ? void 0 : _this$lowcode.url2cdn(src)) || src : src;
  }
  getCustomRenderComponent(scope) {
    if (this.isFunctionRenderType) {
      return Vue.extend({
        render: h => typeof this.render === 'function' ? this.render(h, scope) : h('span', this.getContent(scope.row))
      });
    } else {
      let renderTemplate = '';
      if (this.isCustomRenderType) renderTemplate = this.renderTemplate || '';else if (this.isComplexRenderType) renderTemplate = this.config.template || '';
      if (renderTemplate) {
        renderTemplate = unescape(renderTemplate).replace(/this\./g, 'rootVm.')
        // 兼容老的写法
        .replace(/\$\./g, 'rootVm.');
        const {
          rootVm
        } = this;
        return Vue.extend({
          template: renderTemplate,
          data() {
            return {
              scope,
              rootVm
            };
          }
        });
      }
    }
  }
  execButtonAction(action, scope) {
    if (!action) return;
    const func = this.rootVm[action];
    if (typeof func !== 'function') throw new Error(`AmTableColumn action [${action}] is not a function!`);
    func(scope);
  }
  execDropdownMenuAction(scope, args) {
    const action = args[0];
    this.execButtonAction(action, scope);
  }
};
__decorate([Prop(String)], AmTableColumnMixin.prototype, "prop", void 0);
__decorate([Prop(String)], AmTableColumnMixin.prototype, "label", void 0);
__decorate([Prop(String)], AmTableColumnMixin.prototype, "width", void 0);
__decorate([Prop(String)], AmTableColumnMixin.prototype, "minWidth", void 0);
__decorate([Prop(String)], AmTableColumnMixin.prototype, "type", void 0);
__decorate([Prop(String)], AmTableColumnMixin.prototype, "align", void 0);
__decorate([Prop(Boolean)], AmTableColumnMixin.prototype, "showOverflowTooltip", void 0);
__decorate([Prop(Boolean)], AmTableColumnMixin.prototype, "resizable", void 0);
__decorate([Prop(String)], AmTableColumnMixin.prototype, "fixed", void 0);
__decorate([Prop([Boolean, String])], AmTableColumnMixin.prototype, "sortable", void 0);
__decorate([Prop([Boolean, String])], AmTableColumnMixin.prototype, "hideColumn", void 0);
__decorate([Prop({
  type: String,
  default: 'text'
})], AmTableColumnMixin.prototype, "renderType", void 0);
__decorate([Prop(String)], AmTableColumnMixin.prototype, "renderTemplate", void 0);
__decorate([Prop(Boolean)], AmTableColumnMixin.prototype, "actionDivider", void 0);
__decorate([Prop(Array)], AmTableColumnMixin.prototype, "actions", void 0);
__decorate([Prop(Object)], AmTableColumnMixin.prototype, "builtInTemplateConfig", void 0);
__decorate([Prop(String)], AmTableColumnMixin.prototype, "clearPadding", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], AmTableColumnMixin.prototype, "expandContentNoPadding", void 0);
__decorate([Prop(Function)], AmTableColumnMixin.prototype, "renderHeader", void 0);
__decorate([Prop(Function)], AmTableColumnMixin.prototype, "render", void 0);
__decorate([Prop(Function)], AmTableColumnMixin.prototype, "formatter", void 0);
AmTableColumnMixin = __decorate([Component({
  name: 'AmTableColumnMixin'
})], AmTableColumnMixin);
export default AmTableColumnMixin;